import { VROPS_MAPPED_NODE_NAMES } from 'vrlcm-gui-constants';
import {
  EnvironmentRequestProduct,
  EnvironmentState,
  NodeProperties,
  ProductNode,
  RequestState,
  RequestType,
  VcfInfraProperties
} from 'vrlcm-gui-types';
import { generateUniqueId } from '../utils/Helpers';

const initialVcfProperties: VcfInfraProperties = {
  vcfEnabled: true,
  sddcManagerDetails: []
};
export const getWorkflowSkeleton = (): EnvironmentState => ({
  requestId: '',
  requestType: RequestType.CREATE_ENVIRONMENT,
  requestState: RequestState.UI_INPROGRESS,
  uiData: '{}',
  resultData: '',
  lastUpdatedOn: new Date().getTime(),
  environmentRequestDTO: {
    environmentId: '',
    environmentName: '',
    infrastructure: {
      properties: {
        dataCenterVmid: '',
        regionName: '',
        zoneName: '',
        vCenterName: '',
        vCenterHost: '',
        vcUsername: '',
        vcPassword: '',
        acceptEULA: 'false',
        enableTelemetry: 'true',
        defaultPassword: '',
        certificate: '',
        cluster: '',
        storage: '',
        folderName: '',
        resourcePool: '',
        diskMode: '',
        network: '',
        masterVidmEnabled: 'false',
        vmwareSSOEnabled: 'false',
        dns: '',
        domain: '',
        gateway: '',
        netmask: '',
        searchpath: '',
        timeSyncMode: 'host',
        ntp: '',
        isDhcp: 'false',
        vcfProperties: JSON.stringify(initialVcfProperties),
        _selectedProducts: '[]',
        _isRedeploy: 'false',
        _isResume: 'false',
        _leverageProximity: 'false',
        __isInstallerRequest: 'false'
      }
    },
    products: []
  },
  environmentDescription: ''
});

export const vraSkeleton: EnvironmentRequestProduct = {
  id: 'vra',
  version: '',
  clusterVIP: {
    clusterVips: []
  },
  properties: {},
  nodes: []
};

export const vidmSkeleton: EnvironmentRequestProduct = {
  id: 'vidm',
  version: '',
  clusterVIP: null,
  properties: {},
  nodes: []
};

export const genericSkeleton: EnvironmentRequestProduct = {
  id: '',
  version: '',
  clusterVIP: null,
  properties: {},
  nodes: []
};

export const getVropsCaDefaultNodes = (vrops: EnvironmentRequestProduct) => {
  const pairId = generateUniqueId();
  let masterNode = vrops.nodes.find(n => n.type === 'master');
  masterNode = {
    type: 'master',
    properties: {
      __group: 'master',
      __pairId: pairId,
      vmName: VROPS_MAPPED_NODE_NAMES.master,
      ip: '',
      hostName: '',
      ...masterNode?.properties
    }
  };
  let replicaNode = vrops.nodes.find(n => n.type === 'replica');
  replicaNode = {
    type: 'replica',
    properties: {
      __group: 'replica',
      __pairId: pairId,
      vmName: VROPS_MAPPED_NODE_NAMES.replica,
      ip: '',
      hostName: '',
      ...replicaNode?.properties
    }
  };
  let witnessNode = vrops.nodes.find(n => n.type === 'witness');
  witnessNode = {
    type: 'witness',
    properties: {
      __group: 'witness',
      vmName: VROPS_MAPPED_NODE_NAMES.witness,
      ip: '',
      hostName: '',
      ...witnessNode?.properties
    }
  };
  return [masterNode, replicaNode, witnessNode];
};

export const getVropsCaDataNodePair = (
  suffix: number,
  masterDomainProps?: NodeProperties,
  replicaDomainProps?: NodeProperties
) => {
  const pairId = generateUniqueId();
  const nodeInMasterDomain: ProductNode = {
    type: 'data',
    properties: {
      __group: 'master',
      __pairId: pairId,
      vmName: `${VROPS_MAPPED_NODE_NAMES.data}-${suffix + 1}`,
      ip: '',
      hostName: '',
      ...masterDomainProps
    }
  };
  const nodeInReplicaDomain: ProductNode = {
    type: 'data',
    properties: {
      __group: 'replica',
      __pairId: pairId,
      vmName: `${VROPS_MAPPED_NODE_NAMES.data}-${suffix + 2}`,
      ip: '',
      hostName: '',
      ...replicaDomainProps
    }
  };
  return [nodeInMasterDomain, nodeInReplicaDomain];
};

export const getVropsCaDataNodes = (dataNodePairCount: number) => {
  const dataNodes: ProductNode[] = [];
  for (let i = 0; i < dataNodePairCount; i++) {
    const [nodeInMasterDomain, nodeInReplicaDomain] = getVropsCaDataNodePair(
      i * 2
    );
    dataNodes.push(nodeInMasterDomain);
    dataNodes.push(nodeInReplicaDomain);
  }
  return dataNodes;
};

export const getVropsCaRemoteCollector = (suffix: number) => {
  const pairId = generateUniqueId();
  const remoteCollectorNode: ProductNode = {
    type: 'remotecollector',
    properties: {
      __group: 'remotecollector',
      __pairId: pairId,
      vmName: `${VROPS_MAPPED_NODE_NAMES.remotecollector}-${suffix + 1}`,
      ip: '',
      hostName: ''
    }
  };
  return remoteCollectorNode;
};

export const getVropsCaCloudProxy = (suffix: number) => {
  const pairId = generateUniqueId();
  const remoteCollectorNode: ProductNode = {
    type: 'cloudproxy',
    properties: {
      __group: 'cloudproxy',
      __pairId: pairId,
      vmName: `${VROPS_MAPPED_NODE_NAMES.cloudproxy}-${suffix + 1}`,
      ip: '',
      hostName: ''
    }
  };
  return remoteCollectorNode;
};
